export const GET_USER_DATA = 'GET_USER_DATA';
export const REMOVE_SEGMENT = 'REMOVE_SEGMENT';
export const OPT_OUT = 'OPT_OUT';
export const OPT_IN = 'OPT_IN';

export const ALL = 'ALL';